'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isReact15 = isReact15;
exports.isReact16 = isReact16;
exports.isReact15Up = isReact15Up;

var _utils = require('./utils');
/**
 * Checks to see if React is v15, by checking the provided component.
 * @param {React.Component} Component The React component.
 * @returns {boolean}
 */


function isReact15(Component) {
  return (0, _utils.isObject)(Component) && Component._reactInternalInstance;
}
/**
 * Checks to see if React is v16, by checking the provided component.
 * @param {React.Component} Component The React component.
 * @returns {boolean}
 */


function isReact16(Component) {
  return (0, _utils.isObject)(Component) && Component._reactInternalFiber;
}
/**
 * Checks to see if React is v15 and up, by checking the provided component.
 * @param {React.Component} Component The React component.
 * @returns {boolean}
 */


function isReact15Up(Component) {
  return isReact15(Component) || isReact16(Component);
}